import React, { useState, useMemo, } from 'react';
import { AutoComplete, Input, Row, Col, Button, } from 'antd';
import debounce from 'lodash/debounce';
import { FormattedMessage, useIntl, } from "react-intl";
import { SearchCustomers, } from '../../services/customer';
import CustomerAddModal from '../../containers/customers/modal/customer.add.modal';
import { User, UserPlus } from '@phosphor-icons/react';
import { LoadingOutlined, } from '@ant-design/icons';
import EmptyImage from '../../assets/images/empty.svg';

const SearchCustomersInput = ({
    history,
    setValue,
    ...props
}) => {

    const [data, setData] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [selectedItemInput, setSelectedItemInput] = useState();
    const [searchValue, setSearchValue] = useState();
    const [openAddCustomerModal, setOpenAddCustomerModal] = useState(false);
    const intl = useIntl();

    const handleChange = (value) => {


    };

    const handleSelect = (newValue) => {
        // set the customer name for input value
        setSelectedItemInput(data.find(item => item.customer_id === newValue)?.customer_name);
        // set the choosen value to the useForm object
        setValue("customer_id", newValue);
    };


    const searchDebounce = useMemo(() => {
        const searchCustomer = (value) => {
            setData([]);
            setSearchValue(value);
            if (value) {
                setLoadingData(true);
                SearchCustomers({ search: value }, history)
                    .then(response => {
                        setData(response.data.customer_list);
                        setLoadingData(false);
                    })
                    .catch(error => {
                        console.error('error: ', error);
                    });
            }
        };

        return debounce(searchCustomer, 800);
    }, [history]);


    const renderItem = (record) => {

        return <div
            style={{
                // display: 'flex',
                // justifyContent: 'space-between',
            }}>

            <Row align="middle" justify="space-around">
                <Col span={24} className="mb-2">
                    <div className="font-weight-bolder"><User size={18} className="mr-1" /> {record.customer_name}</div>
                    <div className="font-weight-light">{record.customer_data?.customer_contact_data?.customer_email}</div>
                    <div className="font-weight-light">{record.customer_data?.customer_address?.street_number}</div>
                    <div className="font-weight-light"> {record.customer_data?.customer_address?.zip_code} {record.customer_data?.customer_address?.city}</div>
                </Col>
            </Row>

        </div>

    };

    const emptyContent = () => {

        return <div className="p-4 text-center">
            {loadingData ? (<LoadingOutlined />) : (
                <div>
                    <div><img alt="empty" src={EmptyImage} /></div>
                    {searchValue ? (
                        <div>
                            <div>
                                <p><FormattedMessage id="customer-search-empty" /></p>
                                <p><FormattedMessage id="customer-search-empty-add" /></p>
                            </div>
                            <Button
                                className="mt-2"
                                onClick={() => setOpenAddCustomerModal(true)}
                                icon={<UserPlus size={16} />}>
                                <FormattedMessage id="customer-add" /></Button>
                        </div>
                    ) : (
                        <div><FormattedMessage id="customer-search-start" /></div>
                    )}
                </div>
            )}
        </div>;
    };

    return (

        <React.Fragment>

            <AutoComplete
                style={{ width: "100%" }}
                showSearch
                value={selectedItemInput}
                defaultActiveFirstOption={true}
                suffixIcon={null}
                filterOption={false}
                onSearch={searchDebounce}
                onSelect={handleSelect}
                onChange={handleChange}
                allowClear={true}
                onClear={(e) => { handleSelect(undefined); setData([]); }}
                options={(data || []).map((d) => ({
                    value: d.customer_id,
                    label: renderItem(d),
                }))}
                notFoundContent={emptyContent()}
            >
                <Input.Search
                    loading={loadingData}
                    disabled={loadingData}
                    placeholder={intl.formatMessage({ id: "start-type-to-search" })}
                />
            </AutoComplete>

            {openAddCustomerModal && (
                <CustomerAddModal
                    modalIsOpen={openAddCustomerModal}
                    modalIsOpenHandler={setOpenAddCustomerModal}
                    history={history}
                    refreshData={handleChange}
                    {...props}
                />
            )}
        </React.Fragment>
    );
};


export default SearchCustomersInput;
